<template>
<svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M5 0.953125V2.10734H0V4.41578H1V19.4206C1 20.0329 1.21071 20.62 1.58579 21.0529C1.96086 21.4859 2.46957 21.7291 3 21.7291H13C13.5304 21.7291 14.0391 21.4859 14.4142 21.0529C14.7893 20.62 15 20.0329 15 19.4206V4.41578H16V2.10734H11V0.953125H5ZM5 6.72422H7V17.1122H5V6.72422ZM9 6.72422H11V17.1122H9V6.72422Z" :fill="fill"/>
</svg>
</template>

<script>
  export default {
    name: 'icon-remove',
    props: {
      fill: {
        type: String,
        default: 'currentColor'
      }
    }
  }
</script>